import { useNavigate } from 'react-router-dom';
import Card from '../components/card/Card';
import H from '../components/texts/h/H';
import Button from '../components/button/Button';
import Icon from '../components/icon/Icon';
import Tooltip from '../components/tooltip/Tooltip';
import { useConfig } from '../context/ConfigContext';
import { routes } from '../routes/routePaths';
import { COMITE_LEVEL_ROLES } from '../utils/Constants';
import {
  isQuotationsSettingsGateEnabled,
  showCommissionsConfigurationSection,
} from '../utils/settingsTenantSections';
import { hasAnyRole } from '../utils/Utils';

const Settings = () => {
  const navigate = useNavigate();
  const config = useConfig();
  const isGuaranteesEnabled = config.isGuaranteesEnabled;
  const isQuotationsEnabled = config.isQuotationsEnabled;
  const showQuotationsSettingsSections = isQuotationsSettingsGateEnabled(config);
  const showCommissionsSection = showCommissionsConfigurationSection(config);
  const canConfigureRegulacionSepyme = hasAnyRole(COMITE_LEVEL_ROLES);

  const handleModifyRates = () => {
    navigate(routes.rateTypes);
  };

  const handleCompanyData = () => {
    navigate(routes.sgr);
  };

  const handlePartners = () => {
    navigate(routes.partners);
  };

  const handleShares = () => {
    navigate(routes.shares);
  };

  const handleFunds = () => {
    navigate(routes.funds);
  };

  const handleAssetsToIntegrate = () => {
    navigate(routes.assetsToIntegrate);
  };

  const handleQuotations = () => {
    navigate(routes.quotations);
  };

  const handleCommissions = () => {
    navigate(routes.commissions);
  };

  const handleReferrers = () => {
    navigate(routes.referrers);
  };

  const handleRegulacionSepyme = () => {
    if (!canConfigureRegulacionSepyme) {
      return;
    }
    navigate(routes.regulacionSepyme);
  };

  return (
    <Card variant='neutral' modifier='inverted' spacing='4' height='-webkit-fill-available' width='85vw'>
      <Card display='flex' justifyContent='space-between' alignItems='center' margin={{ bottom: '3' }}>
        <H withMargin={false} type='1' weight='bold' modifier='strong'>
          Configuración
        </H>
      </Card>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
        {isGuaranteesEnabled && (
          <div style={{ border: '1px solid #DFE6EB', borderRadius: '8px', padding: '16px' }}>
            <Card 
              display='flex' 
              justifyContent='space-between' 
              alignItems='center'
            >
              <H withMargin={false} variant="secondary-2" type='2' weight='bold' modifier='strong'>
                Modificar tipo de tasas
              </H>
              
              <Button
                variant="primary"
                size='lg'
                onClick={handleModifyRates}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <Icon name='settings_outline' width={20} height={20} variant='neutral' modifier='inverted' />
                  Configurar
                </div>
              </Button>
            </Card>
          </div>
        )}

        {isGuaranteesEnabled && (
          <div style={{ border: '1px solid #DFE6EB', borderRadius: '8px', padding: '16px' }}>
            <Card 
              display='flex' 
              justifyContent='space-between' 
              alignItems='center'
            >
              <Card display='flex' alignItems='center' gap='8px'>
                <Icon name='company' width={24} height={24} variant='secondary-2' />
                <H withMargin={false} variant="secondary-2" type='2' weight='bold' modifier='strong'>
                  Mis datos de empresa
                </H>
              </Card>
              
              <Button
                variant="primary"
                size='lg'
                onClick={handleCompanyData}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <Icon name='settings_outline' width={20} height={20} variant='neutral' modifier='inverted' />
                  Configurar
                </div>
              </Button>
            </Card>
          </div>
        )}

        {isGuaranteesEnabled && (
          <div style={{ border: '1px solid #DFE6EB', borderRadius: '8px', padding: '16px' }}>
            <Card 
              display='flex' 
              justifyContent='space-between' 
              alignItems='center'
            >
              <H withMargin={false} variant="secondary-2" type='2' weight='bold' modifier='strong'>
                Socios
              </H>
              
              <Button
                variant="primary"
                size='lg'
                onClick={handlePartners}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <Icon name='settings_outline' width={20} height={20} variant='neutral' modifier='inverted' />
                  Configurar
                </div>
              </Button>
            </Card>
          </div>
        )}

        {isGuaranteesEnabled && (
          <div style={{ border: '1px solid #DFE6EB', borderRadius: '8px', padding: '16px' }}>
            <Card
              display='flex'
              justifyContent='space-between'
              alignItems='center'
            >
              <H withMargin={false} variant="secondary-2" type='2' weight='bold' modifier='strong'>
                Acciones
              </H>

              <Button
                variant="primary"
                size='lg'
                onClick={handleShares}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <Icon name='settings_outline' width={20} height={20} variant='neutral' modifier='inverted' />
                  Configurar
                </div>
              </Button>
            </Card>
          </div>
        )}

        {isGuaranteesEnabled && (
          <div style={{ border: '1px solid #DFE6EB', borderRadius: '8px', padding: '16px' }}>
            <Card
              display='flex'
              justifyContent='space-between'
              alignItems='center'
            >
              <H withMargin={false} variant="secondary-2" type='2' weight='bold' modifier='strong'>
                Fondos
              </H>
              
              <Button
                variant="primary"
                size='lg'
                onClick={handleFunds}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <Icon name='settings_outline' width={20} height={20} variant='neutral' modifier='inverted' />
                  Configurar
                </div>
              </Button>
            </Card>
          </div>
        )}

        {isGuaranteesEnabled && (
          <div style={{ border: '1px solid #DFE6EB', borderRadius: '8px', padding: '16px' }}>
            <Card 
              display='flex' 
              justifyContent='space-between' 
              alignItems='center'
            >
              <H withMargin={false} variant="secondary-2" type='2' weight='bold' modifier='strong'>
                Activos a integrar
              </H>
              
              <Button
                variant="primary"
                size='lg'
                onClick={handleAssetsToIntegrate}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <Icon name='settings_outline' width={20} height={20} variant='neutral' modifier='inverted' />
                  Configurar
                </div>
              </Button>
            </Card>
          </div>
        )}
        {showQuotationsSettingsSections && (
        <div style={{ border: '1px solid #DFE6EB', borderRadius: '8px', padding: '16px' }}>
          <Card 
            display='flex' 
            justifyContent='space-between' 
            alignItems='center'
          >
            <H withMargin={false} variant="secondary-2" type='2' weight='bold' modifier='strong'>
              Activos a cotizar
            </H>
            
            <Button
              variant="primary"
              size='lg'
              onClick={handleQuotations}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <Icon name='settings_outline' width={20} height={20} variant='neutral' modifier='inverted' />
                Configurar
              </div>
            </Button>
          </Card>
        </div>
        )}

        {showCommissionsSection && (
          <div style={{ border: '1px solid #DFE6EB', borderRadius: '8px', padding: '16px' }}>
            <Card
              display='flex'
              justifyContent='space-between'
              alignItems='center'
            >
              <H withMargin={false} variant="secondary-2" type='2' weight='bold' modifier='strong'>
                Comisiones
              </H>

              <Button
                variant="primary"
                size='lg'
                onClick={handleCommissions}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <Icon name='settings_outline' width={20} height={20} variant='neutral' modifier='inverted' />
                  Configurar
                </div>
              </Button>
            </Card>
          </div>
        )}

        {showQuotationsSettingsSections && (
          <div style={{ border: '1px solid #DFE6EB', borderRadius: '8px', padding: '16px' }}>
            <Card
              display='flex'
              justifyContent='space-between'
              alignItems='center'
            >
              <H withMargin={false} variant="secondary-2" type='2' weight='bold' modifier='strong'>
                Referidos
              </H>

              <Button
                variant="primary"
                size='lg'
                onClick={handleReferrers}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <Icon name='settings_outline' width={20} height={20} variant='neutral' modifier='inverted' />
                  Configurar
                </div>
              </Button>
            </Card>
          </div>
        )}

        {isGuaranteesEnabled && (
          <div style={{ border: '1px solid #DFE6EB', borderRadius: '8px', padding: '16px' }}>
            <Card
              display='flex'
              justifyContent='space-between'
              alignItems='center'
            >
              <H withMargin={false} variant="secondary-2" type='2' weight='bold' modifier='strong'>
                Regulación SePyME
              </H>

              {canConfigureRegulacionSepyme ? (
                <Button
                  variant="primary"
                  size='lg'
                  onClick={handleRegulacionSepyme}
                >
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <Icon name='settings_outline' width={20} height={20} variant='neutral' modifier='inverted' />
                    Configurar
                  </div>
                </Button>
              ) : (
                <Tooltip
                  position='top'
                  msg='Requiere permiso de Administrador.'
                >
                  <Button
                    variant="primary"
                    size='lg'
                    disabled
                  >
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <Icon name='settings_outline' width={20} height={20} variant='neutral' modifier='inverted' />
                      Configurar
                    </div>
                  </Button>
                </Tooltip>
              )}
            </Card>
          </div>
        )}
      </div>
    </Card>
  );
};

export default Settings;